// extracted by mini-css-extract-plugin
module.exports = {"abs-block":"index_abs-block_1BIE0"};